<template>
  <h3 class="pb5">Partage par responsable pour les dossiers(CDX_0101)</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersPartagesParResponsable",
  components: {ButtonBar},
  data() {
    return {
      critereRecherche: {}
    };
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Partage");
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      this.critereRecherche.nomRapport = "partage.DossiersPartagesParResponsable_CDX_0101";
      this.$store.dispatch("rapports/obtenirRapportAction", this.critereRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
}
</script>